const state = {
  zendeskChatOpen: false
};

const getters = {
  getZendeskChatState: state => {
    return state.zendeskChatOpen;
  },
  isThereNoLiveEventsInOrg: (state, getters, rootState) => {
    return Object.values(rootState.studioEventList.events ?? {}).every((event: any) => {
      const now = new Date();
      const liveStartTime = new Date(event.start_time);
      liveStartTime.setHours(liveStartTime.getHours() - 1);
      return event.is_test || now < liveStartTime;
    });
  }
};

const mutations = {
  setZendeskChatState(state, isOpen) {
    state.zendeskChatOpen = isOpen;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
